import { request } from '@applyboard/ui-utils';
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
function isExpectedResponse(data) {
  var _data$data;
  return typeof (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.token) === 'string';
}
export var getZendeskChatToken = function getZendeskChatToken() {
  return (
    // eslint-disable-next-line  no-restricted-syntax
    request('/api/v0.1/integrations/zendesk/chat_token', {
      isExpectedResponse: isExpectedResponse
    })
  );
};